import { ProductsActionTypes } from './products.types';

export const initialState = {
  loading: false,
  loaded: false,
  owned: [
    {
      category: 'shared',
      has_product: false,
    },
    {
      category: 'domain',
      has_product: false,
    },
    {
      category: 'titan',
      has_product: false,
    },
    {
      category: 'dedicated',
      has_product: false,
    },
    {
      category: 'security',
      has_product: false,
    },
    {
      category: 'academy',
      has_product: false,
    },
  ],
  consultedProducts: [],
  cPanelLoading: false,
  alertsList: [],
  alertsVisibility: false,
  listLoading: false,
  listLoaded: false,
  list: [],
  n8n: {
    hostingId: null,
    actionType: null,
    loading: false,
    data: null,
  },
  userProducts: null,
  loadingUserProducts: false,
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ProductsActionTypes.GET_ALL_PRODUCTS:
      return {
        ...state,
        listLoading: true,
      };
    case ProductsActionTypes.SET_ALL_PRODUCTS_LIST:
      return {
        ...state,
        list: action.payload,
      };
    case ProductsActionTypes.GET_ALL_PRODUCTS_FAILURE:
    case ProductsActionTypes.GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        listLoaded: true,
        listLoading: false,
      };
    case ProductsActionTypes.REQUEST_GET_PRODUCTS:
      return {
        ...state,
        loading: true,
      };
    case ProductsActionTypes.GET_PRODUCTS_SET:
      return {
        ...state,
        owned: action.payload,
      };
    case ProductsActionTypes.GET_PRODUCTS_SUCCESS:
    case ProductsActionTypes.GET_PRODUCTS_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case ProductsActionTypes.SET_CPANEL_LOADING:
      return {
        ...state,
        cPanelLoading: action.payload,
      };
    case ProductsActionTypes.SET_ADD_ALERT:
      return {
        ...state,
        alertsList: [action.payload, ...state.alertsList],
      };
    case ProductsActionTypes.SET_CLEAR_NEW_ALERTS:
      return {
        ...state,
        alertsList: action.payload,
      };
    case ProductsActionTypes.SET_ALERTS_VISIBILITY:
      return {
        ...state,
        alertsVisibility: action.payload,
      };
    case ProductsActionTypes.SET_CONSULTED_PRODUCTS_LIST:
      return {
        ...state,
        consultedProducts: [...state.consultedProducts, action.payload],
      };
    case ProductsActionTypes.GET_N8N_REQUEST:
      return {
        ...state,
        n8n: {
          ...state.n8n,
          hostingId: action.payload.hostingId,
          actionType: action.payload.actionType,
          loading: true,
        },
      };
    case ProductsActionTypes.GET_N8N_SET:
      return {
        ...state,
        n8n: {
          ...state.n8n,
          loading: false,
          data: action.payload.vpsData,
          actionType: null,
        },
      };
    case ProductsActionTypes.GET_N8N_FAILURE:
      return {
        ...state,
        n8n: {
          ...state.n8n,
          hostingId: null,
          loading: false,
          actionType: null,
        },
      };
    case ProductsActionTypes.SET_USER_PRODUCTS:
      return {
        ...state,
        userProducts: action.payload,
      };
    case ProductsActionTypes.SET_LOADING_USER_PRODUCTS:
      return {
        ...state,
        loadingUserProducts: action.payload,
      };
    case ProductsActionTypes.GET_USER_PRODUCTS_SUCCESS:
    case ProductsActionTypes.GET_USER_PRODUCTS_FAILURE:
      return {
        ...state,
        loadingUserProducts: false,
      };
    default:
      return state;
  }
};

export default productsReducer;
